'use client';

import { AuthenticPlace } from "@/app/lib/generated/graphql-types";
import { useSplitContent } from "@/app/features/shared/split-content/contexts/SplitContentProvider";
import { Button } from "@mui/material";
import { PictureAsPdf } from "@mui/icons-material";
import MediaView from "@/app/features/shared/media-view/ui/public/MediaView.public";
import AuthenticPlacesMiniMap from "@/app/features/sites/authentic-places/ui/shared/AuthenticPlacesMiniMap";

export default function AuthenticPlaceSectionBackground({ place }: { place: AuthenticPlace }) {
    const { isHorizontal, isLeading, splitPosition } = useSplitContent();
    const flyerUrl = place.flyer?.url;

    const buttonSide = isHorizontal ? (isLeading ? 'top right' : 'top left') : 'top left';

    return (
        <>
            <MediaView
                src={place.image}
                fill
                magnifier="image"
                infoViewType="image"
                detailsMenuPosition={buttonSide}
                showDetailsMenu
            />
            <AuthenticPlacesMiniMap place={place} />
            {flyerUrl && (
                <Button
                    className="z-[100] bottom-4"
                    component="a"
                    href={flyerUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    sx={{
                        position: 'absolute',
                        right: isHorizontal && !isLeading ? `calc(${100-splitPosition}% + 16px)` : 16,
                        transition: 'right 0.3s ease'
                    }}
                    startIcon={<PictureAsPdf/>}
                    aria-label={`PDF-Tafel zu ${place.title} in neuem Tab öffnen`}
                >
                    Was steht auf der Tafel?
                </Button>
            )}
        </>
    )
}
